export const CATEGORIES = {
  TELEFONARE: { id: "TELEFONARE", label: "Telefonare", icon: "Phone", color: "bg-blue-100 text-blue-700", border: "border-blue-500", accent: "blue" },
  INVIARE_MAIL: { id: "INVIARE_MAIL", label: "Mail", icon: "Mail", color: "bg-indigo-100 text-indigo-700", border: "border-indigo-500", accent: "indigo" },
  PROGETTARE: { id: "PROGETTARE", label: "OFFERTE", icon: "FileText", color: "bg-purple-100 text-purple-700", border: "border-purple-500", accent: "purple" },
  PAGARE: { id: "PAGARE", label: "Pagare", icon: "CreditCard", color: "bg-red-100 text-red-700", border: "border-red-500", accent: "red" },
  ORDINARE: { id: "ORDINARE", label: "Ordinare", icon: "ShoppingCart", color: "bg-orange-100 text-orange-700", border: "border-orange-500", accent: "orange" },
  VERIFICARE: { id: "VERIFICARE", label: "Verificare", icon: "CheckSquare", color: "bg-yellow-100 text-yellow-700", border: "border-yellow-500", accent: "yellow" },
  ASSISTENZE: { id: "ASSISTENZE", label: "Assistenze", icon: "LifeBuoy", color: "bg-teal-100 text-teal-700", border: "border-teal-500", accent: "teal" },
  CREDITI: { id: "CREDITI", label: "Crediti/sblocco", icon: "DollarSign", color: "bg-emerald-100 text-emerald-700", border: "border-emerald-500", accent: "emerald" },
  ACCONTI: { id: "ACCONTI", label: "Acconti", icon: "Wallet", color: "bg-cyan-100 text-cyan-700", border: "border-cyan-500", accent: "cyan" },
  RECALL: { id: "RECALL", label: "Recall", icon: "Repeat", color: "bg-pink-100 text-pink-700", border: "border-pink-500", accent: "pink" },
};

export const QUOTES = [
  "Il tempo è denaro, non sprecarlo.",
  "Organizza oggi per liberare il domani.",
  "Fai prima le cose difficili.",
  "La disciplina è la chiave della libertà.",
  "Un passo alla volta verso l'obiettivo.",
  "Ordine mentale, efficienza reale.",
  "Ogni minuto pianificato ne salva dieci.",
  "Non rimandare a domani ciò che puoi fare oggi.",
  "L'efficienza è fare meglio ciò che va fatto.",
  "Concentrati sull'essenziale, ignora il superfluo.",
];

export const FREQUENCIES = {
  "1M": "Mensile",
  "3M": "Trimestrale",
  "6M": "Semestrale",
  "1Y": "Annuale",
  MANUAL: "Data Specifica",
};
